module.exports = __webpack_public_path__ + "img/icon-diamond.b840fa9f.svg";